import logo from './logo.svg';
import './App.css'; 

import ReactDOM from "react-dom/client";
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";

import Components from "./pages/Components";
import Aide from "./pages/Aide";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Forgotpassword from "./pages/Forgotpassword";
import LoginAlready from "./pages/LoginAlready";
import Partie_blocs from "./pages/Partie_blocs";
import Partie_fin from "./pages/Partie_fin";
import Partie_lettre from "./pages/Partie_lettre";
import Scores_partie from "./pages/Scores_partie";
import Scores from "./pages/Scores";
import Signup from "./pages/Signup";
import Splashscreen from "./pages/Splashscreen";
import Worders from "./pages/Worders";
import Nopage from "./pages/Nopage";


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/">
          <Route index element={<Components />} />
          <Route path="components" element={<Components />} /> 
          <Route path="aide" element={<Aide />} /> 
          <Route path="home" element={<Home />} /> 
          <Route path="login" element={<Login />} /> 
          <Route path="loginalready" element={<LoginAlready />} /> 
          <Route path="partieblocs" element={<Partie_blocs />} /> 
          <Route path="partiefin" element={<Partie_fin />} /> 
          <Route path="partielettre" element={<Partie_lettre />} /> 
          <Route path="scorespartie" element={<Scores_partie />} /> 
          <Route path="scores" element={<Scores />} /> 
          <Route path="signup" element={<Signup />} /> 
          <Route path="splashscreen" element={<Splashscreen />} /> 
          <Route path="forgotpassword" element={<Forgotpassword />} /> 
          <Route path="worders" element={<Worders />} /> 
        </Route>
        <Route path="*" element={<Nopage />} /> 
      </Routes>
    </Router>
  );
}

export default App;
